module.exports = __webpack_public_path__ + "static/img/s1.8bef0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s1.png
// module id = gJZA
// module chunks = 1